module.exports = __webpack_public_path__ + "img/printUserCode.dfdcd502.png";